import styled, { css } from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';

export type TableCellProps = {
  highlight?: boolean;
};

const commonCellStyling = css<TableCellProps>`
  padding: ${spacing(2)} ${spacing(1)};
  ${fonts.paragraphSmall}

  ${mediaQuery.tabletPortrait`
    padding: ${spacing(2)} ${spacing(4)};
    ${fonts.paragraph}
  `}

  ${mediaQuery.tabletLandscape`
    padding: ${spacing(2)} ${spacing(4)};
  `}

  ${({ highlight }) =>
    highlight &&
    css`
      background-color: ${colors.neutral06};
    `}
`;

export const StyledTableCell = styled.td`
  ${commonCellStyling}
`;

export const StyledTableHeaderCell = styled.th`
  ${commonCellStyling}

  ${mediaQuery.tabletLandscape`
    ${fonts.headingXSmall}
  `}
`;

export const InnerContainer = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;

  // Ensures that e.g. RichText children span the whole width of the cell,
  // allowing text alignment etc. to work properly.
  & > *:only-child {
    width: 100%;
  }
`;
